import { IPlannerVehicleRow } from "../models/ProductionPlanner";

// Mirrors DismantlingRollover.IsUnfinished on the API, so the planner agrees with the
// Unfinished list and the nightly rollover. A vehicle's job is finished when it's been
// marked complete, or every part is accounted for (removed or damaged — partsTotal
// already excludes damaged parts, so partsRemoved reaching partsTotal means nothing is
// left to strip). A vehicle with no parts recorded at all is still unfinished.
export function isPlannerVehicleComplete(
  vehicle: Pick<IPlannerVehicleRow, "isJobComplete" | "partsRemoved" | "partsTotal">
): boolean {
  return (
    vehicle.isJobComplete ||
    (vehicle.partsTotal > 0 && vehicle.partsRemoved >= vehicle.partsTotal)
  );
}
